import {
  Button,
  CloseButton,
  FormFieldGroup,
  Grid,
  Heading,
  IconAddLine,
  IconButton,
  IconExternalLinkLine,
  Link,
  List,
  Modal,
  ScreenReaderContent,
  Text,
  TextInput,
  ToggleGroup,
  Tooltip,
  View,
} from "@instructure/ui";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { TaxonomyService } from "../services/TaxonomyService";

export default function LearningTaxonomy() {
  const { t } = useTranslation();
  const [openLearningTaxonomyModal, setOpenLearningTaxonomyModal] =
    useState(false);
  const [openTaxonomyLevelModal, setOpenTaxonomyLevelModal] = useState(false);
  const [componentDataIsInitialized, setComponentDataIsInitialized] =
    useState(false);
  const [name, setName] = useState("");
  const [url, setUrl] = useState("");
  const [currentLearningTaxonomyIndex, setCurrentLearningTaxonomyIndex] =
    useState(0);
  const [taxonomyLevelName, setTaxonomyLevelName] = useState("");
  const [taxonomyLevelWeight, setTaxonomyLevelWeight] = useState("");
  const [taxonomyLevelOrder, setTaxonomyLevelOrder] = useState("");
  const [taxonomyLevelCognates, setTaxonomyLevelCognates] = useState("");
  const [learningTaxonomyList, setLearningTaxonomyList] = useState([]);
  // const [taxonomyToDelete, setTaxonomyToDelete] = useState({});
  // const [removeTaxonomyDialogOpen, setRemoveTaxonomyDialogOpen] =
  //   useState(false);

  useEffect(() => {
    TaxonomyService.getAllTaxonomies().then((taxonomies) => {
      processTaxonomies(taxonomies);
      setComponentDataIsInitialized(true);
    });
  }, []);

  function processTaxonomies(taxonomies) {
    const taxonomyList = [];
    for (const taxonomyObject of taxonomies) {
      const learningTaxonomy = {};
      learningTaxonomy.id = taxonomyObject.id;
      learningTaxonomy.name = taxonomyObject.title;
      learningTaxonomy.url = taxonomyObject.url;
      learningTaxonomy.levelList = [];
      for (const levelKey of Object.keys(taxonomyObject.objectives)) {
        const levelObject = taxonomyObject.objectives[levelKey];

        const level = {};
        level.name = levelObject.title;
        level.order = levelObject.sequence;
        level.cognates = levelObject.cognates;
        learningTaxonomy.levelList.push(level);
      }
      learningTaxonomy.levelList.sort(compareTaxonomyLevelSequence);
      taxonomyList.push(learningTaxonomy);
    }
    setLearningTaxonomyList(taxonomyList);
  }

  // const showDeleteTaxonomyConfirmation = (taxonomyToDelete) => {
  //   setRemoveTaxonomyDialogOpen(true);
  //   setTaxonomyToDelete(taxonomyToDelete);
  // };

  // const clickNoRemoveTaxonomy = () => {
  //   setRemoveTaxonomyDialogOpen(false);
  // };

  function compareTaxonomyLevelSequence(a, b) {
    return a.order - b.order;
  }

  function initLearningTaxonomyModal() {
    setOpenLearningTaxonomyModal(!openLearningTaxonomyModal);
  }

  function closeLearningTaxonomyModal() {
    setOpenLearningTaxonomyModal(false);
    setName("");
    setUrl("");
  }

  function initTaxonomyLevelModal(index) {
    setOpenTaxonomyLevelModal(!openTaxonomyLevelModal);
    setCurrentLearningTaxonomyIndex(index);
  }

  function closeTaxonomyLevelModal() {
    setOpenTaxonomyLevelModal(false);
    setTaxonomyLevelName("");
    setTaxonomyLevelOrder("");
    setTaxonomyLevelWeight("");
    setTaxonomyLevelCognates("");
  }

  function saveTaxonomyLevel(e) {
    e.preventDefault();

    const taxonomyId = learningTaxonomyList[currentLearningTaxonomyIndex].id;
    const taxonomyLevel = {};

    taxonomyLevel.name = taxonomyLevelName;
    taxonomyLevel.order = taxonomyLevelOrder;
    taxonomyLevel.weight = taxonomyLevelWeight;
    taxonomyLevel.cognates = taxonomyLevelCognates;
    persistTaxonomyLevel(taxonomyId, taxonomyLevel);
  }

  function persistTaxonomyLevel(taxonomyId, taxonomyLevel) {
    TaxonomyService.createTaxonomyLevel(taxonomyId, taxonomyLevel).then(
      (response) => {
        taxonomyLevel.id = response.id;
        learningTaxonomyList[currentLearningTaxonomyIndex].levelList.push(
          taxonomyLevel
        );
        learningTaxonomyList[currentLearningTaxonomyIndex].levelList.sort(
          compareTaxonomyLevelSequence
        );
        closeTaxonomyLevelModal();
      }
    );
  }

  function saveLearningTaxonomy(e) {
    e.preventDefault();

    const learningTaxonomy = {};

    learningTaxonomy.name = name;
    learningTaxonomy.url = url;
    learningTaxonomy.levelList = [];

    persistTaxonomy(learningTaxonomy);
  }

  const persistTaxonomy = (learningTaxonomy) => {
    TaxonomyService.createTaxonomy(learningTaxonomy).then((response) => {
      learningTaxonomy.id = response.id;
      learningTaxonomyList.push(learningTaxonomy);
      setLearningTaxonomyList([...learningTaxonomyList]);
      closeLearningTaxonomyModal();
    });
  };

  // function deleteTaxonomy() {
  //   if (taxonomyToDelete.id) {
  //     TaxonomyService.deleteTaxonomyById(taxonomyToDelete.id).then(() =>
  //       setLearningTaxonomyList([
  //         ...learningTaxonomyList.filter(
  //           (taxonomy) => taxonomy !== taxonomyToDelete
  //         ),
  //       ])
  //     );
  //   } else {
  //     setLearningTaxonomyList([
  //       ...learningTaxonomyList.filter(
  //         (taxonomy) => taxonomy !== taxonomyToDelete
  //       ),
  //     ]);
  //   }
  //   setRemoveTaxonomyDialogOpen(false);
  // }

  function renderCloseButton(functionName) {
    return (
      <CloseButton
        placement="end"
        offset="small"
        onClick={eval(functionName)}
        screenReaderLabel={t("global.close")}
      />
    );
  }

  function renderSummary(learningTaxonomy, index) {
    return (
      <div id={"learning-taxonomy-summary-" + index} className="ig-header">
        <Grid hAlign="space-between" vAlign="middle">
          <Grid.Row>
            <Grid.Col>
              <Text>{learningTaxonomy.name}</Text>
            </Grid.Col>
            <Grid.Col width="auto">
              {learningTaxonomy.url && (
                <Tooltip
                  renderTip={t("learningTaxonomy.urlTooltip")}
                  on={["hover", "focus"]}
                  placement="bottom"
                >
                  <Link
                    margin="0 small"
                    href={learningTaxonomy.url}
                    target="_blank"
                    renderIcon={IconExternalLinkLine}
                  >
                    <ScreenReaderContent>
                      {t("learningTaxonomy.urlLinkScreenReaderContent")}
                    </ScreenReaderContent>
                  </Link>
                </Tooltip>
              )}
              <Tooltip
                renderTip={t("learningTaxonomy.taxonomyLevelTooltip")}
                on={["hover", "focus"]}
                placement="bottom"
              >
                <IconButton
                  margin="0 small"
                  screenReaderLabel={t("learningTaxonomy.taxonomyLevelTooltip")}
                  onClick={() => initTaxonomyLevelModal(index)}
                >
                  <IconAddLine />
                </IconButton>
              </Tooltip>
              {/* <Tooltip
                renderTip={t("learningTaxonomy.deleteTaxonomyLevelToolTip")}
                on={["hover", "focus"]}
                placement="bottom"
              >
                <IconButton
                  margin="0 small"
                  screenReaderLabel={
                    t("learningTaxonomy.deleteLearningTaxonomyScreenReaderLabel"
                  )}
                  onClick={() =>
                    showDeleteTaxonomyConfirmation(learningTaxonomy)
                  }
                >
                  <IconTrashLine />
                </IconButton>
              </Tooltip> */}
            </Grid.Col>
          </Grid.Row>
        </Grid>
      </div>
    );
  }

  return (
    <>
      <Grid vAlign="middle" hAlign="end" colSpacing="none">
        <Grid.Row>
          <Grid.Col width="auto">
            <Button
              color="primary"
              id="add-learning-taxonomy-button"
              renderIcon={IconAddLine}
              onClick={initLearningTaxonomyModal}
            >
              {t(
                "learningTaxonomy.addLearningTaxonomyModalFieldGroupDescription"
              )}
            </Button>
            <Modal
              as="form"
              id="learning-taxonomy-modal"
              open={openLearningTaxonomyModal}
              onDismiss={closeLearningTaxonomyModal}
              onSubmit={saveLearningTaxonomy}
              size="medium"
              label={t("learningTaxonomy.addLearningTaxonomyModalLabel")}
              shouldCloseOnDocumentClick
            >
              <Modal.Header>
                {renderCloseButton("initLearningTaxonomyModal")}
                <Heading level="h2" as="h1">
                  {t("learningTaxonomy.addLearningTaxonomyModalHeading")}
                </Heading>
              </Modal.Header>
              <Modal.Body>
                <FormFieldGroup
                  description={
                    <ScreenReaderContent>
                      {t(
                        "learningTaxonomy.addLearningTaxonomyModalFieldGroupDescription"
                      )}
                    </ScreenReaderContent>
                  }
                  rowSpacing="small"
                  layout="stacked"
                  vAlign="middle"
                >
                  <TextInput
                    id="learning-taxonomy-name"
                    renderLabel={t(
                      "learningTaxonomy.addLearningTaxonomyModalNameLabel"
                    )}
                    onChange={(_event, value) => {
                      setName(value);
                    }}
                    isRequired
                  />
                  <TextInput
                    id="learning-taxonomy-url"
                    renderLabel={t(
                      "learningTaxonomy.addLearningTaxonomyModalUrlLabel"
                    )}
                    type="url"
                    onChange={(_event, value) => {
                      setUrl(value);
                    }}
                  />
                </FormFieldGroup>
              </Modal.Body>
              <Modal.Footer>
                <Button
                  onClick={closeLearningTaxonomyModal}
                  margin="0 x-small 0 0"
                >
                  {t("global.cancel")}
                </Button>
                <Button
                  id="save-learning-taxonomy"
                  color="primary"
                  type="submit"
                >
                  {t("global.save")}
                </Button>
              </Modal.Footer>
            </Modal>

            <Modal
              as="form"
              open={openTaxonomyLevelModal}
              onDismiss={closeTaxonomyLevelModal}
              onSubmit={saveTaxonomyLevel}
              size="medium"
              label={t("learningTaxonomy.addTaxonomyLevelModalLabel")}
              shouldCloseOnDocumentClick
            >
              <Modal.Header>
                {renderCloseButton("initTaxonomyLevelModal")}
                <Heading level="h1" as="h3">
                  {t("learningTaxonomy.addTaxonomyLevelModalHeading")}
                </Heading>
              </Modal.Header>
              <Modal.Body>
                <FormFieldGroup
                  description={t(
                    "learningTaxonomy.addTaxonomyLevelModalFieldGroupDescription"
                  )}
                  rowSpacing="small"
                  layout="stacked"
                  vAlign="middle"
                >
                  <TextInput
                    renderLabel={t(
                      "learningTaxonomy.addTaxonomyLevelModalNameLabel"
                    )}
                    onChange={(_event, value) => {
                      setTaxonomyLevelName(value);
                    }}
                    isRequired
                  />
                  <TextInput
                    renderLabel={t(
                      "learningTaxonomy.addTaxonomyLevelModalOrderLabel"
                    )}
                    onChange={(_event, value) => {
                      setTaxonomyLevelOrder(value);
                    }}
                    isRequired
                  />
                  <TextInput
                    renderLabel={t(
                      "learningTaxonomy.addTaxonomyLevelModalWeightLabel"
                    )}
                    onChange={(_event, value) => {
                      setTaxonomyLevelWeight(value);
                    }}
                  />
                  <TextInput
                    renderLabel={t(
                      "learningTaxonomy.addTaxonomyLevelModalCognatesLabel"
                    )}
                    onChange={(_event, value) => {
                      setTaxonomyLevelCognates(value);
                    }}
                  />
                </FormFieldGroup>
              </Modal.Body>
              <Modal.Footer>
                <Button
                  onClick={closeTaxonomyLevelModal}
                  margin="0 x-small 0 0"
                >
                  {t("global.cancel")}
                </Button>
                <Button color="primary" type="submit">
                  {t("global.save")}
                </Button>
              </Modal.Footer>
            </Modal>
          </Grid.Col>
        </Grid.Row>
        {!componentDataIsInitialized && (
          <Grid.Row>
            <Grid.Col>
              <Skeleton
                count={3}
                style={{ height: 64, borderRadius: 5, marginBottom: "1.5rem" }}
              />
            </Grid.Col>
          </Grid.Row>
        )}
        {componentDataIsInitialized &&
          learningTaxonomyList.map((learningTaxonomy, index) => (
            <Grid.Row key={index}>
              <Grid.Col>
                <ToggleGroup
                  toggleLabel={t(
                    "learningTaxonomy.learningTaxonomyToggleScreenReaderLabel"
                  )}
                  summary={renderSummary(learningTaxonomy, index)}
                >
                  <View display="block" padding="small">
                    <List isUnstyled>
                      {learningTaxonomy.levelList.map((level) => (
                        <List.Item key={level.name}>
                          <Text color="primary">
                            {level.order} - {level.name}
                          </Text>
                          <Text color="secondary" wrap="break-word">
                            <em> ({level.cognates})</em>
                          </Text>
                        </List.Item>
                      ))}
                    </List>
                  </View>
                </ToggleGroup>
              </Grid.Col>
            </Grid.Row>
          ))}
      </Grid>
      {/* <DialogYesNo
        message={t("learningTaxonomy.deleteLearningTaxonomyMessage")}
        openStatus={removeTaxonomyDialogOpen}
        onClickNo={clickNoRemoveTaxonomy}
        onClickYes={deleteTaxonomy}
      /> */}
    </>
  );
}
